<template>
<div class="home">
    <fcheader></fcheader>
    <div class="separate"></div>
    <fccontent></fccontent>
    <fcfooter></fcfooter>
</div>
</template>

<script>
// @ is an alias to /src
import fcheader from '@/components/headercon.vue'
import fcfooter from '@/components/footer.vue'
import fccontent from './content.vue'
export default {
    name: 'Home',
    components: {
        fcheader,
        fcfooter,
        fccontent
    },
    data() {
        return {}
    }
}
</script>

<style lang="scss" scoped>
.separate {
    height: 108px;
}

.home {
    overflow-y: auto;
}
</style>
